module.exports = __webpack_public_path__ + "img/default.81ad1b6d.png";